import React, {useEffect} from 'react';
import './App.scss';
import AppRoutes from './routes/AppRoutes';
import {ToastProvider} from './contexts/toastContext/ToastContext';
import {ModalProvider} from './contexts/modalContext/ModalContext';
import {AuthorizationProvider} from './contexts/authorizationContext/AuthorizationContext';
import {StyledEngineProvider} from '@mui/material/styles';
import {useTranslation} from 'react-i18next';
import {clearLocalSessionStorage, removeAuthToken} from './utils/auth';
import {persistor} from './redux/store';

const App: React.FC = () => {
  const {t} = useTranslation();

  useEffect(() => {
    document.title = t('app.title');
  }, [t]);

  const handleBeforeUnload = async () => {
    removeAuthToken();
    await persistor.purge();
    localStorage.removeItem('persist:root');
    clearLocalSessionStorage();
  };
  useEffect(() => {
    if (window.location.pathname === '/login') {
      handleBeforeUnload();
    }
  }, []);

  return (
    <AuthorizationProvider>
      <div className="App">
        <StyledEngineProvider injectFirst>
          <ToastProvider>
            <ModalProvider>
              <AppRoutes />
            </ModalProvider>
          </ToastProvider>
        </StyledEngineProvider>
      </div>
    </AuthorizationProvider>
  );
};

export default App;
